export default __webpack_public_path__ + "static/media/542.e7327e57.png";